import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAsset1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 10.2723H10.25M14.75 6.25H4.95M4.95 6.25H0.75V15.25H10.25V10.2723M4.95 6.25V0.75H14.75V10.2723H10.25",
		stroke: "#212121",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgAsset1;
